import { EquipmentCategory } from 'components/structure-page/modals/add-equipment-modal-config';

type DiagramProps = {
  className?: string;
};

function OutdoorUnitDiagram({ className }: DiagramProps) {
  return (
    <svg
      viewBox='0 0 120 120'
      className={className}
      fill='none'
      stroke='currentColor'
      aria-hidden
    >
      <rect x='22' y='28' width='76' height='68' rx='4' strokeWidth='2.5' />
      <circle cx='60' cy='58' r='22' strokeWidth='2' />
      <circle cx='60' cy='58' r='6' strokeWidth='1.75' />
      <line x1='60' y1='36' x2='60' y2='80' strokeWidth='1.5' />
      <line x1='38' y1='58' x2='82' y2='58' strokeWidth='1.5' />
      <line x1='44' y1='42' x2='76' y2='74' strokeWidth='1.5' />
      <line x1='76' y1='42' x2='44' y2='74' strokeWidth='1.5' />
      <line
        x1='22'
        y1='96'
        x2='98'
        y2='96'
        strokeWidth='2.5'
        strokeLinecap='round'
      />
    </svg>
  );
}

function IndoorUnitDiagram({ className }: DiagramProps) {
  return (
    <svg
      viewBox='0 0 120 120'
      className={className}
      fill='none'
      stroke='currentColor'
      aria-hidden
    >
      <rect x='24' y='20' width='72' height='80' rx='4' strokeWidth='2.5' />
      <rect x='32' y='30' width='56' height='28' rx='2' strokeWidth='1.75' />
      <path
        d='M38 38h44M38 46h44M38 54h44'
        strokeWidth='1.75'
        strokeLinecap='round'
      />
      <rect x='40' y='68' width='16' height='22' rx='1.5' strokeWidth='1.75' />
      <rect x='64' y='68' width='16' height='22' rx='1.5' strokeWidth='1.75' />
    </svg>
  );
}

function BlowerUnitDiagram({ className }: DiagramProps) {
  return (
    <svg
      viewBox='0 0 120 120'
      className={className}
      fill='none'
      stroke='currentColor'
      aria-hidden
    >
      <rect x='34' y='10' width='52' height='100' rx='4' strokeWidth='2.5' />
      <rect x='42' y='20' width='36' height='18' rx='2' strokeWidth='1.75' />
      <line x1='46' y1='26' x2='74' y2='26' strokeWidth='1.75' />
      <line x1='46' y1='32' x2='74' y2='32' strokeWidth='1.75' />
      <circle cx='60' cy='64' r='16' strokeWidth='2' />
      <circle cx='60' cy='64' r='5' strokeWidth='1.75' />
      <path d='M60 48v32M44 64h32M49 53l22 22M71 53L49 75' strokeWidth='1.5' />
      <rect x='42' y='88' width='36' height='14' rx='2' strokeWidth='1.75' />
    </svg>
  );
}

function PackagedUnitDiagram({ className }: DiagramProps) {
  return (
    <svg
      viewBox='0 0 120 120'
      className={className}
      fill='none'
      stroke='currentColor'
      aria-hidden
    >
      <rect x='14' y='38' width='92' height='48' rx='4' strokeWidth='2.5' />
      <line x1='60' y1='38' x2='60' y2='86' strokeWidth='2' />
      <circle cx='37' cy='62' r='14' strokeWidth='2' />
      <circle cx='37' cy='62' r='4' strokeWidth='1.5' />
      <circle cx='83' cy='62' r='14' strokeWidth='2' />
      <circle cx='83' cy='62' r='4' strokeWidth='1.5' />
      <rect x='22' y='86' width='76' height='8' rx='2' strokeWidth='2' />
    </svg>
  );
}

const DIAGRAMS: Record<
  EquipmentCategory,
  (props: DiagramProps) => JSX.Element
> = {
  'outdoor-unit': OutdoorUnitDiagram,
  'indoor-unit': IndoorUnitDiagram,
  'blower-unit': BlowerUnitDiagram,
  'packaged-unit': PackagedUnitDiagram
};

type ExistingEquipmentTypeDiagramProps = {
  kind: EquipmentCategory;
  className?: string;
};

export default function ExistingEquipmentTypeDiagram({
  kind,
  className
}: ExistingEquipmentTypeDiagramProps) {
  const Diagram = DIAGRAMS[kind];
  return <Diagram className={className} />;
}
